import { combineReducers } from "redux";

import { reducer as auditReducer } from "./components/ClientCard/components/CardWorkflows/components/ExportAuditTrail/reducer";

export const reducer = combineReducers({
  audit: auditReducer,
});
export default reducer;
